export default __webpack_public_path__ + "static/logo_v-match@big-48d3ad38e80b0ff18ac9e987f40d1f93.png";